module.exports = __webpack_public_path__ + "static/media/weather_notification.84f39abf.svg";